<template>
  <div class="page-product-chart-box">
    <div class="page-header">
      <h2>{{ $t("DashboardProduct.paneltitle1") }}
        <el-button v-if="showcharts" size="mini" @click="hiddencharts()">{{$t("charts.hide")}} <i class="el-icon-arrow-up el-icon--right"></i></el-button>
        <el-button v-if="!showcharts" size="mini" @click="hiddencharts()">{{$t("charts.show")}} <i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <b>{{ $t('report.s58') }}</b>
        <el-switch
            v-model="lowpricechk"
            active-value="1"
            inactive-value="2"
            active-color="#13ce66"
            inactive-color="#9d9d9d"
            @change="showLowpriceDashboard">
        </el-switch>
        <span style="float:right; font-size:14px;">{{$t("charts.latestupdate")}}：{{latestupdatetime}}</span>
      </h2>
    </div>

    <div v-if="showcharts">
      <div class="dashboard-row">
        <div class="dashboard-col-200">
          <div class="dashboard-container dashboard-height-400">
            <NumberCard 
              :firsttitle="lowpricechk == 1 ? $t('jgjk.s999') : $t('jgjk.s9990')"
              :firstnumber="dashboardModel.total_fakes"
              :firstunit="$t('jgjk.s73')"
              :secondtitle="$t('jgjk.s2')"
              :secondnumber="dashboardModel.fakes_percent"
              :secondunit="$t('DashboardProduct.secondunit')"
              :subid="showsubid"
              :nodata="false"
              routename="LowPricedProductsLinks"
            />
          </div>
        </div>
        <div class="dashboard-col-auto">
          <el-row>
            <el-col :span="12" style="padding-right:10px;">
              <div class="dashboard-container">
                <PieChart
                  chartheight="301px"
                  legendtype="vertical"
                  chartid="piechartdataid"
                  :charttitle="lowpricechk == 1 ? $t('jgjk.s3001') : $t('jgjk.s3002')"
                  :chartdata="piechartdata"
                />
              </div>
            </el-col>
            <el-col :span="12" style="padding-left:10px;">
              <div class="dashboard-container">
                <LineChart 
                  chartid="line1"
                  :charttitle="lowpricechk == 1 ? $t('jgjk.s4001') : $t('jgjk.s4002')" 
                  :chartdata="linechartdata"
                  :animation="true"
                />
              </div>              
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="dashboard-row" v-if="showpricechange">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="dashboard-container">
              <div class="dashboard-newbar">
                <h2>{{ $t('jgjk.s222') }}</h2>
              </div>
              <div class="dashboard-newbar-container">
                <div class="dashboard-newbar-content" id="new1"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="dashboard-container">
              <div class="dashboard-newbar">
                <h2>{{ $t('jgjk.s223') }}</h2>
              </div>
              <div class="dashboard-newbar-container">
                <div class="dashboard-newbar-content" id="new2"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
    
  </div>
</template>

<script>
import NumberCard from '../Charts/NumberCard.vue'
import PieChart from '../Charts/ChartPie.vue'
import LineChart from '../Charts/LineChart.vue'
export default {
  // props: {
  //   setLowPriceType: String
  // },
  components:{
    NumberCard,
    LineChart,
    PieChart
  },
  data(){
    return{
      lowpricechk: JSON.parse(localStorage.getItem("lowpricechk")) != null 
                && JSON.parse(localStorage.getItem("lowpricechk")) != undefined 
                && JSON.parse(localStorage.getItem("lowpricechk")) != '' 
                ? JSON.parse(localStorage.getItem("lowpricechk")).val : '2',
      showpricechange: true,
      latestupdatetime: '',
      showcharts: true,
      barchartshow1: false,
      barchartshow2: false,
      top10brandchartdata: {},
      queryDate : {
        start_date : this.$store.state.startDate,
        end_date : this.$store.state.endDate
      },
      FakeProductValueTrade: {
        xdatetime: [],
        yvalue: []
      },
      dashboardModel:{
        total_fakes : '',
        fakes_percent : ''
      },
      dsahboard: {},
      linechartdata: {},
      barchartdata: {},
      piechartdata: {},
      subid: this.$route.params.Id,
      series: '',
      model: '',
      showsubid: false
    }
  },
  mounted(){
    let that = this
    let ifshowcharts = JSON.parse(localStorage.getItem("showcharts"))
    if(ifshowcharts === null){
      that.requestDashboardData(that.$route.params.Id)
      that.showcharts = true
    }else{
      that.requestDashboardData(that.$route.params.Id)
      that.showcharts = false
    }

  },

  methods:{

    showLowpriceDashboard: function(val){
      /**
       * 1 低价； 2 全部
       */
      this.setLocalStorage( "lowpricechk", val)
      this.initCharts(this.dsahboard)
    },

    /**
     * 隐藏图表
     */
    hiddencharts: function(){
      let that = this
      let types = that.showcharts
      if(types === true){
        that.showcharts = false
        that.setLocalStorage( "showcharts", false )
      }else{
        that.showcharts = true
        localStorage.removeItem("showcharts")
        that.requestDashboardData(that.$route.params.Id)
      }
    },

    /**
     * 生成图表
     */
    initCharts: function(rex){
      let that = this

      // 数字图
      that.dashboardModel.total_fakes = that.lowpricechk == 1 ? 
                                        that.millonFormat(rex.results[0][0][0].FakeProductCount) : 
                                        that.millonFormat(rex.results[0][0][1].ProductCount)
      that.dashboardModel.fakes_percent= rex.results[1][0].FakeProductRate === null ? '0%' : rex.results[1][0].FakeProductRate
      that.showsubid = rex.results[0][0][0].FakeProductCount > 0 || rex.results[0][0][1].ProductCount > 0 ? 
                       that.$route.params.Id : false

      /**
       * 最新各渠道低价商品链接分布图
       */
       let pieresults = that.lowpricechk == 1 ? rex.results[2][0] : rex.results[2][1]
      let piechartdataitem = []
      let legendDataitem = []
      for(let i=0; i<pieresults.length; i++){
        let _pie = {}
        _pie.value = pieresults[i].Count
        _pie.name = that.setChannel(pieresults[i].Channel).loc
        _pie.itemStyle = {
          color: that.setChannel(pieresults[i].Channel).color
        }
        piechartdataitem.push(_pie)
        legendDataitem.push(_pie.name)
      }
      that.piechartdata = {
        legendData: legendDataitem,
        seriesData: piechartdataitem
      }

      // 最近7天低价商品数量变化及趋势
      let lineChartDataObj = that.lowpricechk == 1 ? rex.results[3][0] : rex.results[3][1]
      let x = [];
      let y = [];
      for (var i = 0; i < lineChartDataObj.length; i++) {
          x[i] = that.$moment(that.lowpricechk == 1 ? lineChartDataObj[i].FakeData : lineChartDataObj[i].Data).format('MM-DD')
          y[i] = that.lowpricechk == 1 ? lineChartDataObj[i].FakeValue : lineChartDataObj[i].Value
      }
      that.linechartdata = {
        xAxis: x,
        yAxis: [{
          type: 'line',
          smooth: true,
          data: y
        }]
      }

      let _diffv = rex.results[4]
      let _diffc = rex.results[5]
      let _data1 = {
        datetime: [],
        s1: [],
        s2: []
      }
      let _data2 = {
        datetime: [],
        s1: [],
        s2: []
      }
      // 涨跌数量
      for(let x=0; x<_diffc.length; x++){
        _data1.datetime.push(that.$moment(_diffc[x].diffCount).format('MM-DD'))
        _data1.s1.push(_diffc[x].minCount * 1)
        _data1.s2.push(_diffc[x].maxCount * 1)
      }
      // 涨跌金额
      for(let y=0; y<_diffv.length; y++){
        _data2.datetime.push(that.$moment(_diffv[y].diffValues).format('MM-DD'))
        _data2.s1.push(_diffv[y].minValues * 1 > 0 ? 0 : _diffv[y].minValues * 1)
        _data2.s2.push(_diffv[y].maxValues * 1 < 0 ? 0 : _diffv[y].maxValues * 1)
      }
      let _showpricechange = that.sumArr(_data1.s1) * 1 + that.sumArr(_data1.s2)
      that.showpricechange = _showpricechange * 1 == 0 ? false : true
      
      that.sevenDaysProducts(_data1, 'new1')
      that.sevenDaysAmount(_data2, 'new2')

      /**
       * latestupdatetime
       */
      that.latestupdatetime = rex.results[6][0].CurrentDate
      that.setLocalStorage( "latestupdatetimeeditsku", rex.results[6][0].CurrentDate )
    },

    /**
     * 求和
     */
    sumArr: function(arr) {
      let s = 0;
      for (var i=arr.length-1; i>=0; i--) {
        s += arr[i];
      }
      return s
    },

    /**
     * 获取所有图表
     */
    requestDashboardData: function(subid) {
      let that = this
      let requestQuery = {
        start: '',
        end: '',
        subid: subid,
      }
      $.ajax({
        url:  this.API_URL + '/v3/price/monitor/dashboard',
        type: "GET",
        data: requestQuery,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          that.dsahboard = rex
          that.$emit('updateData', rex.results[8][0].lowpriceDiscount + '')
          that.initCharts(rex)
        },
        error: function(response) {
          if(response.status/1 === 500){
            that.$router.push({ name: 'DataPending', params: {Id: that.subid} })
          }
          if(response.status/1 === 401){
            that.$router.push({ name: 'Login'})
          }
        }
      })
    },

    /**
     * 最近7天涨价／降价商品数量统计
     * 最近7天涨幅／降幅统计
     */
    sevenDaysProducts: function(data, id){
      let that = this
      let myBarChart = this.$echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        legend: {
          top: 10,
          icon: 'pin',
          data: [this.$t('jgjk.s228'), this.$t('jgjk.s229')]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params){
            let _t = [params[1].marker + params[1].seriesName + '：' +  params[1].data,
                      params[0].marker + params[0].seriesName + '：' +  params[0].data]
            return _t.join('<br>')
          }
        },
        grid: {
          left: 50,
          right: 50,
          bottom: 30,
          top: 60,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 0,
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#EAEAEA'
            }
          },
          data: data.datetime
        },
        yAxis: {
          name: this.$t('jgjk.s226'),
          nameLocation: 'middle', 
          nameTextStyle: {
            color: '#000',
          },
          nameGap: 40,
          type: 'value',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto'
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [
          {
            name: this.$t('jgjk.s229'),
            type: 'bar',
            stack: '总量',
            label: {
              color: '#FFFFFF',
              show: false,
              formatter: function(value){
                let _v = ''
                if(value.data * 1 < 10000){
                  _v = value.data * 1
                }
                if(value.data * 1 >=10000 && value.data * 1 < 100000000){
                  _v = (value.data/10000).toFixed(2) + '万'
                }
                if(value.data * 1 >= 100000000){
                  _v = (value.data/100000000).toFixed(2) + '亿'
                }
                return _v
              }
            },
            data: data.s1,
            barWidth: '50%'
          },
          {
            name: this.$t('jgjk.s228'),
            type: 'bar',
            stack: '总量',
            label: {
              color: '#FFFFFF',
              show: false,
              formatter: function(value){
                let _v = ''
                if(value.data * 1 < 10000){
                  _v = value.data * 1
                }
                if(value.data * 1 >=10000 && value.data * 1 < 100000000){
                  _v = (value.data/10000).toFixed(2) + '万'
                }
                if(value.data * 1 >= 100000000){
                  _v = (value.data/100000000).toFixed(2) + '亿'
                }
                return _v
              }
            },
            data: data.s2,
            barWidth: '50%'
          }
        ],
        color: ['#7290F2', '#F47373'],
        animation: false
      })
      $(window).resize(function () {
        myBarChart.resize()
      }); 
    },

    sevenDaysAmount: function(data, id){
      let myBarChart = this.$echarts.init(document.getElementById(id))
      myBarChart.clear()
      myBarChart.setOption({
        legend: {
          top: 10,
          icon: 'pin',
          data: [this.$t('jgjk.s224'), this.$t('jgjk.s225')]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
        },
        grid: {
          left: 50,
          right: 50,
          bottom: 30,
          top: 60,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 0,
          },
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            lineStyle: {
              color: '#4d4d4d'
            }
          },
          data: data.datetime
        },
        yAxis: {
          type: 'value',
          name: this.$t('jgjk.s227'),
          nameLocation: 'middle', 
          nameTextStyle: {
            color: '#000',
          },
          nameGap: 40,
          axisLabel: {
            color: 'rgba(51,51,51,.4)',
            interval: 'auto'
          },
          axisTick: {
            show: false
          },
          axisLine: { 
            show: false,
            lineStyle: {
              color: '#EAEAEA',
            }
          }
        },
        series: [
          {
            name: this.$t('jgjk.s224'),
            type: 'bar',
            stack: '总量',
            label: {
              show: false,
              position: 'insideRight'
            },
            data: data.s2,
            barWidth: '50%'
          },
          {
            name: this.$t('jgjk.s225'),
            type: 'bar',
            stack: '总量',
            label: {
              show: false,
              position: 'insideRight'
            },
            data: data.s1,
            barWidth: '50%'
          }
        ],
        color: ['#F47373', '#7290F2'],
        animation: false
      })
      $(window).resize(function () {
        myBarChart.resize()
      }); 
    },

  }
}
</script>
